//Third itteration of cropping function (works for sure!)
//Re-factored to be a class component. Useful for React ref functionality in parent CropWindow component.
// this part of the app was created using react-easy-crop (link: https://github.com/ricardo-ch/react-easy-crop)

import React, { useState, useCallback } from 'react'
import ReactDOM from 'react-dom'
import Cropper from 'react-easy-crop'
import Slider from '@material-ui/core/Slider'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

//other written components
import ImgDialog from './ImgDialog' //for dialogue blocks
import getCroppedImg from './cropImage' //for exporting cropped image to usable blob

// function component for cropper and sliders using react JS hooks 
export class Crop extends React.Component {
    constructor(props) {
        super(props);
        //set initial state and image based on passed props
        let img = this.props.Img;
        this.state= {
          image: img ,
          crop: { x: 0, y: 0 },
          zoom: 1,
          rotation: 0,
          aspect: 1 / 1,
          croppedAreaPixels: null,
          croppedImage: null,
        }
      }
    // Function that saves cropped area on each change
    onCropComplete = (croppedArea, croppedAreaPixels) => {
            // displays position at each change of the cropper
            //console.log(croppedArea, croppedAreaPixels)

            //Sets cropped area as state
            this.setState({croppedAreaPixels: croppedAreaPixels,})
     }

    returnCroppedImage = async () => {
        await this.stereoHalf(this.state.croppedAreaPixels, this.state.rotation)
        console.log('This component ran')
        return 
    }


    stereoHalf = async (croppedAreaPixels, rotation) => {
        try {
            const croppedImage = await getCroppedImg(
            this.props.Img,
            this.state.croppedAreaPixels,
            this.state.rotation
            ) 
            this.props.callback(this.props.position, croppedImage);
            } 
            catch (e) {
                console.error(e)
            }
        }

    showCroppedImage = async (croppedAreaPixels, rotation) => {
            try {
                const croppedImage = await getCroppedImg(
                this.props.Img,
                this.state.croppedAreaPixels,
                this.state.rotation
                )
                this.setState({croppedImage: croppedImage,})
                console.log('done', this.state.croppedImage)
                } 
            catch (e) {
                console.error(e)
            }
        }

    onClose = () => {
            this.setState({croppedImage: null,})
    }
    //Value Change function
    onCropChange = crop => {
        //crop change functions to set new state
        this.setState({ crop })
      }
    onZoomChange = zoom => {
        // sets new zoom state property
        this.setState({ zoom })
      }
    onRotationChange = rotation =>{
        // sets new rotation state property
        this.setState({rotation})
      }

    render() {
        return (
            <div>
              <div className={this.props.position}>
                <Cropper
                  image={this.props.Img}
                  crop={this.state.crop}
                  rotation={this.state.rotation}
                  zoom={this.state.zoom}
                  aspect={ 1 / 1 }
                  onCropChange={this.onCropChange}
                  onRotationChange={this.onRotationChange}
                  onCropComplete={this.onCropComplete}
                  onZoomChange={this.onZoomChange}
                />
              </div>
              <div className={this.props.sliderPos} id={this.props.position}>
                <div >
                  <Typography
                    variant="overline"
                    id="zoomLabel"
                  >
                    Zoom
                  </Typography>
                  <Slider
                    value={this.state.zoom}
                    min={1}
                    max={3}
                    step={0.01}
                    aria-labelledby="Zoom"
                    onChange={(e, zoom) => this.onZoomChange(zoom)}
                    id='zoomSlider1'
                  />
                </div>
                <div>
                  <Typography
                    variant="overline"
                    id='rotationLabel'
                  >
                    Rotation
                  </Typography>
                  <Slider
                    value={this.state.rotation}
                    min={0}
                    max={360}
                    step={1}
                    aria-labelledby="Rotation"
                    id ='rotationSlider1'
                    onChange={(e,rotation) => this.onRotationChange(rotation)}
                  />
                </div>
                <Button
                  onClick={this.showCroppedImage}
                  variant="contained"
                  color="primary"
                  id={this.props.buttonLoc}
                >
                  Show Crop
                </Button>
              </div>
              <ImgDialog img={this.state.croppedImage} onClose={this.onClose} />
            </div>
          )  
    }      
}

    /*
    //Old function component for reference (cropping 2)

    //Initial constants of function component
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [rotation, setRotation] = useState(0)
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [croppedImage, setCroppedImage] = useState(null) 
  
    // saves crop each time image is moved or zoomed
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
      setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    // function to show cropped images in dialogue (individual)
    const showCroppedImage = useCallback(async () => {
      try {
        const croppedImage = await getCroppedImg(
          props.Img,
          croppedAreaPixels,
          rotation
        )
        console.log('donee', { croppedImage })
        setCroppedImage(croppedImage)
      } catch (e) {
        console.error(e)
      }
    }, [croppedAreaPixels, rotation])



    //closes the crop and resets value
    const onClose = useCallback(() => {
      setCroppedImage(null)
    }, [])
  
    //Standard format for displaying this function component (return function)
    return (
      <div>
        <div className={props.position}>
          <Cropper
            image={props.Img}
            crop={crop}
            rotation={rotation}
            zoom={zoom}
            aspect={ 1 / 1 }
            onCropChange={setCrop}
            onRotationChange={setRotation}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </div>
        <div className={props.sliderPos} id={props.position}>
          <div >
            <Typography
              variant="overline"
              id="zoomLabel"
            >
              Zoom
            </Typography>
            <Slider
              value={zoom}
              min={1}
              max={3}
              step={0.01}
              aria-labelledby="Zoom"
              onChange={(e, zoom) => setZoom(zoom)}
              id='zoomSlider1'
            />
          </div>
          <div>
            <Typography
              variant="overline"
              id='rotationLabel'
            >
              Rotation
            </Typography>
            <Slider
              value={rotation}
              min={0}
              max={360}
              step={1}
              aria-labelledby="Rotation"
              id ='rotationSlider1'
              onChange={(e, rotation) => setRotation(rotation)}
            />
          </div>
          <Button
            onClick={showCroppedImage}
            variant="contained"
            color="primary"
            id={props.buttonLoc}
          >
            Show Crop
          </Button>
        </div>
        <ImgDialog img={croppedImage} onClose={onClose} />
      </div>
    )
  }*/